import { fetchState, type FetchState } from './fetch-state';
import { initializeState, type InitializeState } from './initialize-state';
import {
	markReopenSpotlightAsSeen,
	type MarkReopenSpotlightAsSeen,
} from './mark-reopen-spotlight-as-seen';
import {
	reopenGettingStartedPanel,
	type ReopenGettingStartedPanel,
} from './reopen-getting-started-panel';
import { resolveTask, type ResolveTask } from './resolve-task';
import { savePanelState, type SavePanelState } from './save-panel-state';
import { saveProperty, type SaveProperty } from './save-property';
import {
	setOpsAdminTaskVisibility,
	type SetOpsAdminTaskVisibility,
} from './set-ops-admin-task-visibility';

import {
	stopRecordingPerformanceExperiences,
	type StopRecordingPerformanceExperiences,
} from './stop-recording-performance-experiences';

export const actions = {
	initializeState,
	fetchState,
	savePanelState,
	reopenGettingStartedPanel,
	markReopenSpotlightAsSeen,
	resolveTask,
	saveProperty,
	stopRecordingPerformanceExperiences,
	setOpsAdminTaskVisibility,
} as const;

export type StoreActions = typeof actions;

export type Actions = {
	initializeState: InitializeState;
	fetchState: FetchState;
	savePanelState: SavePanelState;
	reopenGettingStartedPanel: ReopenGettingStartedPanel;
	markReopenSpotlightAsSeen: MarkReopenSpotlightAsSeen;
	resolveTask: ResolveTask;
	saveProperty: SaveProperty;
	stopRecordingPerformanceExperiences: StopRecordingPerformanceExperiences;
	setOpsAdminTaskVisibility: SetOpsAdminTaskVisibility;
};

export type { InitializeState, ReopenGettingStartedPanel };
